/**
 * Shared Amazon URL build options from the page-params snapshot + ad account.
 */

import type { SdkContext } from '../types';
import type { AdAccountConfig } from '../../core/config/types';
import type { AmazonUrlOptions, RuntimeAdTagAssignment } from './amazon';

export function buildAmazonOpts(
  ctx: SdkContext,
  adAccount: AdAccountConfig | null,
  defaultTag: string,
  runtimeAdTagAssignment?: RuntimeAdTagAssignment | null,
  sessionTag?: string | null,
  /** When false, skip `ecom_tags_prefix` check on `?ch=` (yoto `ecmtrtg_man`). */
  enforceTagsPrefix: boolean = true,
): AmazonUrlOptions {
  const pageParams = ctx.getPageParams();
  const useSession = Boolean(sessionTag && !runtimeAdTagAssignment);
  return {
    defaultTag,
    adAccount,
    sessionTag: useSession ? sessionTag : null,
    useSessionAttribution: useSession,
    runtimeAdTagAssignment,
    mbid: pageParams.mediaBuyingId,
    channel: pageParams.channel || null,
    tagsPrefix: ctx.getConfig().ecom.tagsPrefix ?? null,
    enforceTagsPrefix,
  };
}
